import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar as MuiAvatar, makeStyles } from '@material-ui/core';
import { AvatarGroup } from '@material-ui/lab';
const getBackgroundColor = ({ type }, palette) => {
    if (type === 'success') {
        return palette.success.main;
    }
    if (type === 'warning') {
        return palette.warning.main;
    }
    return palette.error.main;
};
const useStyles = makeStyles((theme) => ({
    root: ({ type }) => ({
        backgroundColor: getBackgroundColor({ type }, theme.palette),
        color: theme.name === 'liquidity' ? theme.palette.common.white : theme.palette.liquidity.miscCanvas,
    }),
}));
const Avatar = (props) => {
    const { type, children } = props, rest = __rest(props, ["type", "children"]);
    const classes = useStyles({ type });
    return (_jsx(MuiAvatar, Object.assign({ className: classes.root }, rest, { children: children }), void 0));
};
export { Avatar, AvatarGroup };
//# sourceMappingURL=Avatar.js.map